export function validateName(elementId: string) {
  const regex = new RegExp('^[a-zA-Z]{2,50}$');
  const nameInput = document.getElementById(elementId) as HTMLInputElement;
  const value = nameInput.value;
  return regex.test(value);
}
export function validateZip() {
  const regex = new RegExp('^[0-9]{5}$');
  const zipCodeInput = document.getElementById('zip') as HTMLInputElement;
  const value = zipCodeInput.value;
  return regex.test(value);
}
export function validatePhoneNumber() {
  const phoneNumberInput = document.getElementById('phone') as HTMLInputElement;
  const value = phoneNumberInput.value.replace(/[^a-zA-Z0-9]/g, '');
  const regex = new RegExp('^[0-9]{10}$');
  return regex.test(value);
}
export function validateEmailAddress() {
  // tslint:disable-next-line
  const regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  const emailAddressInput = document.getElementById('email') as HTMLInputElement;
  const value = emailAddressInput.value;
  return regex.test(value);
}
